import { useState } from "owa-react";
/* eslint-disable-next-line owa-custom-rules/forbid-empty-import-statements-from-modules -- (https://aka.ms/OWALintWiki)
 * Baseline. DO NOT COPY AND PASTE!, replace this line with a justification or fix the issue.
 *	> Empty import statements from non-relative modules are not allowed. Either import something specific or remove the import. */
import "@1js/suiteux-shell";

import { createPortal } from "owa-react-dom";
import { isBrowserSafari } from "owa-user-agent";
import React from "react";

import type { CustomizationRegion, LinkClickEventArgs, NavBarLinkData, ShellControl, ShellLayout, NavBarData as ShellNavBarData, SignOutEventArgs, } from "@1js/suiteux-shell-react";
import { SuiteHeader } from "@1js/suiteux-shell-react";
import { OWA_SEARCH_SCOPE_PICKER_ID, OWA_TITLE_BAR_ID } from "owa-header-constants";
import { getAccountScopeUserSettings, isConsumer, isPremiumConsumer } from "owa-session-store";
import getNewScope from "owa-url/lib/getNewScope";
import { getOrigin } from "owa-url/lib/getOrigin";
import getRootVdirName from "owa-url/lib/getRootVdirName";
import { WhatsNewInitSource, initializeWhatsNewCardsLazy } from "owa-whats-new";
import { OwaActivityFeedButtonID } from "../constants";
import { setLeftCharmsRegionWidth } from "./LeftCharmsRegion";
import { OwaDevSourceLabel } from "./OwaDevSourceLabel";
import { OwaLogoOnTileSpace } from "./OwaLogoOnTileSpace";
import { OwaActivityFeedFlexPane, OwaDexFlexPane, OwaDiagFeedbackFlexPane, OwaDiagnosticsFlexPane, OwaDictationHelpFlexPane, OwaExpressionFlexPane, OwaFeedbackFlexPane, OwaGetDiagnosticsFlexPane, OwaGroupsPanelFlexPane, OwaNoteFeedFlexPane, OwaRolloutOverridesFlexPane, OwaSkypeFlexPane, OwaSupportFlexPane, OwaTimePanelFlexPane, OwaTipsFlexPane, OwaAddinsFlexPane, getOwaChatCopilotFlexPane, } from "./OwaSuiteFlexPane";
import { OwaActivityFeedButton, OwaBusinessChatButton, OwaConsumerTeamsChatButton, OwaFeedbackButton, OwaMeetNowButton, OwaNoteFeedButton, OwaPremiumButton, OwaSettingsButton, OwaTimePanelButton, StaleFlightUpdateButtonVisibility, createOwaUpdateAvailableButton, } from "./OwaSuiteHeaderButton";
import loc, { format } from "owa-localize";

import type { IO365ShellShim } from "@1js/suiteux-shell";
import { getGlobalSettingsAccountMailboxInfo } from "owa-account-source-list-store";
import { getUnseenItemsCount } from "owa-activity-feed/lib/store/unseenItemsSelector";
import { logCoreUsage, logUsage, PerformanceDatapoint } from "owa-analytics";
import { getApplicationSettings } from "owa-application-settings";
import setAppPaneUnderlayVisibility from "owa-app-pane-underlay/lib/actions/setAppPaneUnderlayVisibility";
import type { OwaSuiteHeaderProps } from "owa-bootstrap";
import { getBposNavBarData } from "owa-bpos-store";
import { isCapabilityEnabled, isCapabilitySupported } from "owa-capabilities";
import { diagnosticsFeedbackCapability } from "owa-capabilities-definitions/lib/diagnosticsFeedbackCapability";
import { feedbackCapability } from "owa-capabilities-definitions/lib/feedbackCapability";
import { shyHeaderCapability } from "owa-capabilities-definitions/lib/shyHeaderCapability";
import { headerFullBleedCapability } from "owa-capabilities-definitions/lib/headerFullBleedCapability";
import { getApp, isGulpOrBranching, getOwaAppId } from "owa-config";
import { DiagnosticsHostCommon } from "owa-diagnostics-common";
import { OpenAnotherMailboxDialog } from "owa-explicit-logon";
import { isAccountFeatureEnabled, isGlobalFeatureEnabled } from "owa-feature-flags";
import isWin32StylingEnabled from "owa-theme-win32-style-store/lib/selectors/isWin32StylingEnabled";
import { LazyF6TeachingBubble } from "owa-accessibility-loop-teaching-bubble";
import { getPrivacyUrl } from "owa-feedback-common";
import { lazySignout } from "owa-signout";
import { MergedNotificationPane } from "owa-header-charms";
import { initializeStaleFlightUpdateDetector, isStaleFlightUpdateAvailable, isStaleFlightUpdateNotificationEnabled, shouldInitializeStaleFlightUpdateDetector, } from "owa-stale-flight-update";
import { feedbackLink } from "owa-locstrings/lib/strings/feedbacklink.locstring.json";
import { helpLink } from "owa-locstrings/lib/strings/helplink.locstring.json";
import { openAnotherMailbox } from "owa-locstrings/lib/strings/openanothermailbox.locstring.json";
import { privacyChoicesLink } from "owa-locstrings/lib/strings/privacychoiceslink.locstring.json";
import { privacyLink } from "owa-locstrings/lib/strings/privacylink.locstring.json";
import { reportCalendarAbuseLink } from "owa-locstrings/lib/strings/reportcalendarabuselink.locstring.json";
import { termsLink } from "owa-locstrings/lib/strings/termslink.locstring.json";
import { PendingAccountsWelcomeCallout, ICloudSignInTeachingCallout, } from "owa-mail-accounts-view-callout";
import { lazyIsMeetNowEnabled } from "owa-meet-now";
import { getQueryStringParameter } from "owa-querystring";
import { getResourcePathUrl } from "owa-resource-url";
import { DEFAULT_COLLAPSED_WIDTH } from "owa-search-constants";
import { getConfig } from "owa-service/lib/config";
import type WebSessionType from "owa-service/lib/contract/WebSessionType";
import getUserConfiguration from "owa-session-store/lib/actions/getUserConfiguration";
import type OwaWorkload from "owa-workloads/lib/store/schema/OwaWorkload";
import { observer } from "owa-mobx-react";
import { showModal } from "owa-modal";
import { LazyIrisCampaignDialogHost } from "owa-iris-campaign-dialog";
import { isIrisDialogEnabled } from "owa-iris-store";
import { isNewUserPostJit } from "owa-new-user-experience";
import { initializeOneNoteFeed } from "owa-notes-feed-bootstrap";
import { isOcpsStoreReady } from "owa-ocps-policy-store";
import { RepromptDialog, RepromptDialogV2 } from "owa-reprompt-dialog";
import { initializeSkypeForBusiness } from "owa-skype-for-business";
import { setShellButtonCustomBadgeColors, setShellButtonCustomBadgeCount, setShellButtonCustomTooltip, } from "owa-suite-header-apis";
import { lazyGetTeamsPolicies, lazyIsTeamsChatEnabled } from "owa-teams-policies";
import { shouldUseCobranding } from "owa-theme-common";
import { isTimePanelAvailable } from "owa-time-panel-bootstrap";
import { GovernPriority, lazyGovern } from "owa-tti";
import { lazyLaunchUnifiedConsentDialog } from "owa-unified-consent";
import { lazyLaunchInAppFeedback } from "owa-uservoice";
import isWorkloadSupported from "owa-workloads/lib/utils/isWorkloadSupported";
import { notifNewItemsFmt } from "../strings.locstring.json";
import { chatButtonRenderedCallback } from "../utils/chatButtonRenderedCallback";
import { getChatUnreadMessageCallbackPromise, shouldLoadPreAuthOnIdleCallbackPromise, } from "../utils/embedChatOnIdleCallbackPromises";
import { useInitializeViewportAdjustment } from "../utils/viewportAdjustment";
import { fetchTokenForShell } from "../utils/fetchTokenForShell";
import { suiteRenderedCallback } from "../utils/suiteRenderedCallback";
import useOwaBrandTheme from "../utils/useOwaBrandTheme";
import useOwaThemeData from "../utils/useOwaThemeData";
import useSuiteHeaderLanguageProps from "../utils/useSuiteHeaderLanguageProps";
import { TeamsPoliciesScenario } from "owa-teams-policies-store/lib/store/schema";
import { useBlockPlt } from "owa-react-hooks/lib/useBlockPlt";
import { LazyPstTeachingCallout } from "owa-pst-teaching-callout";
import { MeControlLauncher } from "owa-mecontrol-launcher";
import { novaMeControlCapability } from "owa-capabilities-definitions/lib/novaMeControlCapability";
import { timePanelContainer, customFlexPane, copilotFlexPaneHeader } from "./OwaSuiteHeader.scss";
import classNames from "owa-classnames";
import { LazyAddSharedMailboxesAsAccountTeachingCallout } from "owa-shared-with-me-teaching-callout";
import { LazyNotificationSoundCustomizationTeachingCallout } from "owa-notification-sound-customization-teaching-callout";
import { CopilotAutoReschedulingNotificationsCallout } from "owa-auto-rescheduling-notification-callout";
import { customNotificationSoundCapability } from "owa-capabilities-definitions/lib/customNotificationSoundCapability";
import type { MailboxInfo } from "owa-client-types";
import { getMailboxInfoForMeControl } from "owa-mecontrol-launcher/lib/utils/getMailboxInfoForMeControl";
import { getAuthConfig } from "owa-auth-callbacks";
import { MsaTenantId } from "owa-service/lib/constants/ApplicationId";
import createHeaderButtonsRegion from "./createHeaderButtonsRegion";

interface ExtendedWindow {
    O365Shell: IO365ShellShim;
}

declare var window: Window & ExtendedWindow;
const ShellMailId = "ShellMail";

const OWA_CONSUMER_APP_ID = "292841";
const SELECT_ACCOUNT_PARAM = "prompt=select_account";
const LOGIN_HINT_PARAM = "login_hint";
const MaxFeedbackPaneURLFormat = "{0}/f1/home/inappfeedbackaddin?helpid=161255";
const ConsumerSocUrl = "https://support.office.live.com";
const BusinessSocUrl = "https://support.office.com";
const OwaEnterpriseUrl = "https://outlook.office.com";
const BADGE_COLOR_RED = "#D13438";
const APPEND_BOOT_FLIGHTS_PARAM = "appendbootflights";

const defaultExport: React.FunctionComponent<OwaSuiteHeaderProps> = observer(function OwaSuiteHeader(props: OwaSuiteHeaderProps) {
    const isFlightUpdateNotificationEnabled = isStaleFlightUpdateNotificationEnabled();
    const isFlightUpdateAvailable = isFlightUpdateNotificationEnabled && isStaleFlightUpdateAvailable();
    
    React.useEffect(() => {
        if (shouldInitializeStaleFlightUpdateDetector()) {
            initializeStaleFlightUpdateDetector();
        }
        lazyGovern.importAndExecute({
            task: () => lazyLaunchUnifiedConsentDialog.importAndExecute(),
            condition: isGlobalFeatureEnabled("unified-consent-feature") ||
                isGlobalFeatureEnabled("unified-consent-exp-feature"),
            priority: GovernPriority.Lightning,
            name: "lazyLaunchUnifiedConsentDialog",
            // Generated by Copilot. Please update with the correct owners.
            ownership: ["miclo@microsoft.com"],
        });
    }, []);
    
    const [setSearchContainer, searchContainerPortal] = useReactPortal(props.renderSearch);
    const [setSearchScopeContainer, searchScopePortal] = useReactPortal(props.renderSearchScopePicker);
    
    const sessionSettings = getUserConfiguration().SessionSettings;
    const accountScopeSessionSettings = getAccountScopeUserSettings(getGlobalSettingsAccountMailboxInfo()).SessionSettings;
    
    const [setNotificationPaneContainer, notificationPortal] = useReactPortal(() => (<>{<MergedNotificationPane key="notificationPane"/>}</>));
    
    // when fwk-skype-deprecation is deleted, rename the function to "lazyInitializeTeamsChatProvider"
    React.useEffect(() => {
        lazyGovern.importAndExecute({
            task: initializeSkypeForBusiness,
            condition: isGlobalFeatureEnabled("fwk-skypeBusinessV2"),
            priority: GovernPriority.SuiteHeader,
            name: "initializeSkypeForBusiness",
            // Generated by Copilot. Please update with the correct owners.
            ownership: ["miclo@microsoft.com"],
        });
    }, []);
    
    const feedbackNavLink = createHelpLink("OwaFeedbackLink", loc(feedbackLink), undefined, () => {
        lazyLaunchInAppFeedback.importAndExecute();
        return false;
    });
    
    const helpNavLink = createHelpLink("OwaHelpLink", loc(helpLink), "https://go.microsoft.com/fwlink/?linkid=853225");
    
    const privacyNavLink = createHelpLink("OwaPrivacyLink", loc(privacyLink), getPrivacyUrl());
    
    const privacyChoicesNavLink = createHelpLink("OwaPrivacyChoicesLink", loc(privacyChoicesLink), "https://account.microsoft.com/privacy/ad-settings");
    
    const legalNavLink = createHelpLink("OwaTermsLink", loc(termsLink), "https://www.microsoft.com/en-us/servicesagreement");
    
    /* eslint-disable-next-line no-restricted-properties  -- (https://aka.ms/OWALintWiki)
     * Adding IsShadowMailbox to restricted properties/methods.
     *	> 'IsShadowMailbox' is restricted from being used. IsCloudCache/IsShadowMailbox should be resolved in ECS as a filter in a feature flight if possible. */
    const isShadowMailbox = React.useRef(accountScopeSessionSettings?.IsShadowMailbox);
    const isConsumerMailbox = isConsumer(undefined /*smtpAddress*/, getGlobalSettingsAccountMailboxInfo());
    const owaChatEnabled = React.useRef(!(isGlobalFeatureEnabled("fwk-partner-code-off") ||
        isGlobalFeatureEnabled("fwk-teamsSuite")) &&
        (isGlobalFeatureEnabled("fwk-skypeBusinessV2") || isConsumerMailbox) &&
        !isShadowMailbox.current);
    const headerTeamsChatEnabled = React.useRef(isGlobalFeatureEnabled("fwk-teamsSuite"));
    
    const APP_BRAND_THEME = useOwaBrandTheme();
    const baseThemeDataOverride = useOwaThemeData();
    const win32StylingEnabled = isWin32StylingEnabled();
    const themeDataOverride = React.useMemo(() => {
        if (!win32StylingEnabled) {
            return baseThemeDataOverride;
        }
        
        return {
            ...baseThemeDataOverride,
            UserThemePalette: {
                ...baseThemeDataOverride.UserThemePalette,
                NavBar: "transparent",
            },
            TenantThemePalette: {
                ...baseThemeDataOverride.TenantThemePalette,
                NavBar: "transparent",
            },
        };
    }, [baseThemeDataOverride, win32StylingEnabled]);
    const isCobrandingTheme = shouldUseCobranding(themeDataOverride.UserThemeId);
    const isColdStartScenario = React.useRef(true);
    
    // For cold start scenarios, we need to hide the tenant logo for the initial render
    // This is intended to prevent the shell from loading the TenantLogo from the ShellService response.
    const hideTenantLogoForInitialRender = isColdStartScenario.current && isCobrandingTheme && themeDataOverride.IsDarkTheme;
    
    const bPosNavBarData: ShellNavBarData = getBposNavBarData() as ShellNavBarData;
    const navBarData = React.useMemo(() => {
        if (bPosNavBarData) {
            const owaNavBarData: ShellNavBarData = {
                ...bPosNavBarData,
                CurrentMainLinkElementID: ShellMailId,
                ThemeDataOverride: themeDataOverride,
                AppBrandTheme: APP_BRAND_THEME,
                FeedbackLink: feedbackNavLink,
                HelpLink: helpNavLink,
                PrivacyLink: privacyNavLink,
                PrivacyChoicesLink: privacyChoicesNavLink,
                LegalLink: legalNavLink,
                CurrentWorkloadHelpSubLinks: getWorkloadHelpSublinks(bPosNavBarData.CurrentWorkloadHelpSubLinks),
            };
            return owaNavBarData;
        }
        else {
            return undefined;
        }
    }, [bPosNavBarData, themeDataOverride, APP_BRAND_THEME]);
    
    React.useEffect(() => {
        if (navBarData) {
            // A valid cold start scenario is when the theme is dark and is cobranding theme at initial render
            const isValidColdStartScenario = isColdStartScenario.current &&
                navBarData.ThemeDataOverride.IsDarkTheme &&
                isCobrandingTheme;
            const isValidWarmScenario = !isColdStartScenario.current && isCobrandingTheme;
            
            // For valid cold and warm scenarios, we need to fetch and load the TenantLogo from WCSS
            if ((isValidColdStartScenario || isValidWarmScenario) && window.O365Shell) {
                window.O365Shell.Theme.UpdateTenantLogo(navBarData.ThemeDataOverride.IsDarkTheme);
            }
            
            isColdStartScenario.current = false;
        }
    }, [navBarData, isCobrandingTheme]);
    
    const createCustomLayout = (): ShellLayout => {
        const customHeaderButtons: ShellControl[] = [];
        const { renderSearchScopePicker, searchBoxRespond } = props;
        
        pushOnCondition(customHeaderButtons, OwaMeetNowButton, getApplicationSettings("MeetNow").shouldShowInHeader &&
            isConsumer() &&
            (isGlobalFeatureEnabled("fwk-teamsPolicies")
                ? true // If Teams policy flight is enabled, use async call back to control visibility.
                : /* eslint-disable-next-line no-restricted-properties -- (https://aka.ms/OWALintWiki)
                   * BASELINE. Do not copy and paste!
                   *	> 'tryImportForRender' is restricted from being used. tryImportForRender should only be used in rare circumstances and can hurt TTI if used incorrectly. */
                    lazyIsMeetNowEnabled.tryImportForRender()?.()));
        
        const hideChatIntegrationEnabled = isGlobalFeatureEnabled("mon-hide-chat-integration");
        pushOnCondition(customHeaderButtons, isGlobalFeatureEnabled("fwk-skypeBusinessV2")
            ? OwaBusinessChatButton
            : OwaConsumerTeamsChatButton, owaChatEnabled.current && !hideChatIntegrationEnabled);
        
        pushOnCondition(customHeaderButtons, { id: "owaChatButton", nativeControlID: "ChatIcon" } as ShellControl, headerTeamsChatEnabled.current && !hideChatIntegrationEnabled);
        
        pushOnCondition(customHeaderButtons, OwaPremiumButton, isPremiumConsumer(getGlobalSettingsAccountMailboxInfo()) && !isShadowMailbox.current);
        
        // Push button standard header button if flight is enabled
        // and we're not running against Cloud Cache mailbox.
        if (isGlobalFeatureEnabled("notes-noteFeedSidePanel") && !isShadowMailbox.current) {
            pushOnCondition(customHeaderButtons, OwaNoteFeedButton);
            lazyGovern.importAndExecute({
                task: () => initializeOneNoteFeed(),
                priority: GovernPriority.Idle,
                name: "initializeOneNoteFeed",
                // Generated by Copilot. Please update with the correct owners.
                ownership: ["miclo@microsoft.com"],
            });
        }
        
        if (isTimePanelAvailable()) {
            pushOnCondition(customHeaderButtons, OwaTimePanelButton);
        }
        
        pushOnCondition(customHeaderButtons, OwaActivityFeedButton);
        
        const unseenItemsCount = getUnseenItemsCount();
        const showUnseenItemsBadge = unseenItemsCount > 0;
        if (showUnseenItemsBadge) {
            logUsage("ActivityFeed_UnreadBadgeCount", getGlobalSettingsAccountMailboxInfo(), {
                badgeCount: unseenItemsCount,
            });
        }
        setShellButtonCustomBadgeCount(OwaActivityFeedButtonID, unseenItemsCount);
        
        const bellTooltip = showUnseenItemsBadge ? loc(notifNewItemsFmt) : ""; // Empty string = default tooltip (name of the pane)
        setShellButtonCustomTooltip(OwaActivityFeedButtonID, bellTooltip);
        
        const redBadgeColor = {
            badgeColor: BADGE_COLOR_RED,
            badgeHoverColor: BADGE_COLOR_RED,
            badgeFontColor: "white",
            badgeFontHoverColor: "white",
        };
        setShellButtonCustomBadgeColors(OwaActivityFeedButtonID, redBadgeColor);
        
        pushOnCondition(customHeaderButtons, OwaSettingsButton);
        if (isFlightUpdateNotificationEnabled) {
            pushOnCondition(customHeaderButtons, createOwaUpdateAvailableButton(isFlightUpdateAvailable));
        }
        
        if (isCapabilityEnabled(diagnosticsFeedbackCapability) &&
            isGlobalFeatureEnabled("fwk-internalFeedback") &&
            !isAccountFeatureEnabled("mon-diag-feedbackjs", getGlobalSettingsAccountMailboxInfo())) {
            pushOnCondition(customHeaderButtons, OwaFeedbackButton);
        }
        
        // TODO: consider moving this code to Help ribbon once we fully migrate
        if (getApp() === "Oobe" ||
            (isNewUserPostJit() && isGlobalFeatureEnabled("user-intent-survey"))) {
            const initSource: WhatsNewInitSource = isNewUserPostJit()
                ? WhatsNewInitSource.UserIntent
                : WhatsNewInitSource.Oobe;
            initializeWhatsNewCardsLazy.importAndExecute(undefined, initSource);
        }
        else {
            lazyGovern.importAndExecute({
                task: () => initializeWhatsNewCardsLazy.importAndExecute(),
                priority: GovernPriority.Idle,
                name: "initializeWhatsNewCardsLazy",
                // Generated by Copilot. Please update with the correct owners.
                ownership: ["miclo@microsoft.com"],
            });
        }
        
        // Now define responsive behavior for all the custom header buttons, with the
        // right-most one getting dropped first
        customHeaderButtons.forEach((control, index, array) => {
            if (!control.responsiveBehavior) {
                control.responsiveBehavior = {
                    responsivePriority: array.length - 1 - index + 2,
                    minimizeBehavior: "overflow",
                    delayMinimize: false,
                };
            }
            else if (control.responsiveBehavior.responsivePriority == 0) {
                // Update the responsive priorities for the buttons as per its position in the collection
                control.responsiveBehavior.responsivePriority = array.length - 1 - index + 2;
            }
        });
        
        const leftCharms: ShellControl[] = [];
        
        if (!isWin32StylingEnabled()) {
            leftCharms.push({
                id: "owaBranding",
                flex: renderSearchScopePicker ? "1 1 auto" : "",
                nativeControlID: "O365Branding",
                minWidth: "auto",
            } as ShellControl);
        }
        
        leftCharms.unshift({
            id: "tenantLogo",
            nativeControlID: "TenantLogo",
            minWidth: "auto",
        } as ShellControl);
        
        const appLauncherButtonWidth = isGlobalFeatureEnabled("fwk-appLauncher") ? 48 : 0;
        const leftCharmsWidth = (props.searchAlignmentWidth /* getSearchBoxLeftPadding */ ||
            getUserConfiguration().UserOptions?.NavigationBarWidth ||
            228) - appLauncherButtonWidth; /* Subtract the button width */
        if (renderSearchScopePicker) {
            leftCharms.push({
                id: OWA_SEARCH_SCOPE_PICKER_ID,
                flex: "1 1 auto",
                justifyContent: "flex-end",
                minWidth: "auto",
                render: setSearchScopeContainer,
            } as ShellControl);
        }
        
        // When app launcher is not there, we need to leave some space to allow the Outlook logo not to touch the border directly until we find a suitable logo works for all themes.
        if (!isGlobalFeatureEnabled("fwk-appLauncher")) {
            leftCharms.unshift(OwaLogoOnTileSpace);
        }
        
        // Optionally add notification of gulp or branch presence
        if (isGlobalFeatureEnabled("fwk-devTools") && isGulpOrBranching()) {
            leftCharms.unshift(OwaDevSourceLabel);
        }
        
        const owaChatCopilotFlexPane = getOwaChatCopilotFlexPane(classNames(timePanelContainer, customFlexPane), isGlobalFeatureEnabled("mon-copilot-bizchat", true)
            ? copilotFlexPaneHeader
            : undefined);
        
        const flexPaneCollection = [
            OwaFeedbackFlexPane,
            OwaDiagFeedbackFlexPane,
            OwaDiagnosticsFlexPane(DiagnosticsHostCommon),
            OwaRolloutOverridesFlexPane,
            OwaTipsFlexPane,
            OwaSupportFlexPane,
            OwaGetDiagnosticsFlexPane,
            OwaTimePanelFlexPane,
            OwaActivityFeedFlexPane,
            OwaExpressionFlexPane,
            OwaSkypeFlexPane,
            OwaNoteFeedFlexPane,
            OwaGroupsPanelFlexPane,
            owaChatCopilotFlexPane,
            OwaDexFlexPane,
            OwaDictationHelpFlexPane,
            OwaAddinsFlexPane,
        ];
        
        setLeftCharmsRegionWidth("leftCharmsRegion", leftCharmsWidth);
        
        const layout = {
            enableResponsive: !!props.enableResponsiveLayout,
            leftCustomizationRegion: {
                includeAppLauncher: isGlobalFeatureEnabled("fwk-appLauncher"),
            },
            centerCustomizationRegion: {
                alignItems: "center",
                flex: "1 0 auto",
                children: [
                    {
                        /* Left aligned */
                        justifyContent: "flex-start",
                        alignItems: "center",
                        flex: "1 0 auto",
                        children: [
                            {
                                /* Left Charms */
                                regionID: "leftCharmsRegion",
                                children: leftCharms,
                                flex: "0 0 auto",
                                minWidth: `${leftCharmsWidth}px`,
                            } as CustomizationRegion,
                            {
                                /* Search Box */
                                id: "owaSearchBox",
                                flex: "1 0 auto",
                                render: setSearchContainer,
                                respond: (step: number) => searchBoxRespond?.(step),
                                responsiveBehavior: {
                                    responsivePriority: 1,
                                    minimizeBehavior: "custom",
                                    delayMinimize: true,
                                    responsiveSteps: [DEFAULT_COLLAPSED_WIDTH],
                                },
                            } as ShellControl,
                        ],
                    } as CustomizationRegion,
                    createHeaderButtonsRegion(customHeaderButtons, setNotificationPaneContainer),
                ],
            } as CustomizationRegion,
            rightCustomizationRegion: {
                includeMeControl: isGlobalFeatureEnabled("me-controlAccountSwitching") &&
                    !isCapabilitySupported(novaMeControlCapability),
                id: "O365_HeaderRightRegion2",
            },
            flexPaneCollection,
        } as ShellLayout;
        return layout;
    };
    const createMeSublinks = (): NavBarLinkData[] => {
        return !props.hideOpenAnotherMailbox &&
            accountScopeSessionSettings?.WebSessionType === 0
            ? [
                {
                    Id: "OwaOpenTargetMailboxLink",
                    Text: loc(openAnotherMailbox),
                    Url: "javascript:void(0)",
                    Action: showOpenAnotherMailboxDialog,
                },
            ]
            : [];
    };
    
    const userPrincipalName = isShadowMailbox.current
        ? accountScopeSessionSettings?.UserEmailAddress
        : sessionSettings?.UserPrincipalName;
    
    // Prefer login_hint claim over UPN for suite header auth
    // When the flight is off, falls back to the existing UPN-based value.
    const preferLoginHint = isGlobalFeatureEnabled("auth-login-hint-suite-header") && !isShadowMailbox.current;
    const mailboxInfoForHint = preferLoginHint
        ? getGlobalSettingsAccountMailboxInfo()
        : undefined;
    const loginHintForAuth = preferLoginHint
        ? sessionSettings?.LoginHint ||
            (mailboxInfoForHint && getAuthConfig().getLoginHintClaim?.(mailboxInfoForHint)) ||
            sessionSettings?.UserPrincipalName
        : userPrincipalName;
    
    const accountSwitchingEnabled = isGlobalFeatureEnabled("auth-meControl-accountSwitcher") &&
        !isShadowMailbox.current &&
        isGlobalFeatureEnabled("me-controlAccountSwitching");
    
    const isChatEnabled = React.useMemo(async (): Promise<boolean> => {
        // Using getGlobalSettingsAccountMailboxInfo: This telemetry tracks chat feature
        // availability for the global settings account. The header chat integration is
        // tied to the primary account, and the Teams policy checks below use the same
        // mailbox, so telemetry should route to the same endpoint.
        const chatEnabledStatusDataPoint = new PerformanceDatapoint("ChatEnabledStatus", getGlobalSettingsAccountMailboxInfo());
        
        if (isBrowserSafari() || isGlobalFeatureEnabled("mon-hide-chat-integration")) {
            chatEnabledStatusDataPoint.addCustomData({
                isChatEnabled: false,
                disbaledBecauseSafariOrMonarch: true,
            });
            chatEnabledStatusDataPoint.end();
            return false;
        }
        if (isConsumer()) {
            chatEnabledStatusDataPoint.addCustomData({
                isChatEnabled: false,
                disabledBecauseConsumerTenant: true,
            });
            chatEnabledStatusDataPoint.end();
        }
        if (isGlobalFeatureEnabled("fwk-teamsPolicies") && !isConsumer()) {
            const mailboxInfo = getGlobalSettingsAccountMailboxInfo();
            const teamsChatEnabledStatus = await lazyIsTeamsChatEnabled.importAndExecute(TeamsPoliciesScenario.MailEmbedChat, mailboxInfo);
            const teamsPolicies = await lazyGetTeamsPolicies.importAndExecute(TeamsPoliciesScenario.MailEmbedChat, mailboxInfo);
            chatEnabledStatusDataPoint.addCustomData({
                isChatEnabled: teamsChatEnabledStatus,
                isTeamsPoliciesEnabled: true,
                teamsPolicies: JSON.stringify(teamsPolicies),
            });
            
            chatEnabledStatusDataPoint.end();
            return teamsChatEnabledStatus;
        }
        else {
            return headerTeamsChatEnabled.current;
        }
    }, [headerTeamsChatEnabled.current]);
    
    const { culture, language, isRTL } = useSuiteHeaderLanguageProps();
    
    const isFeedbackEnabled = isCapabilityEnabled(feedbackCapability, getGlobalSettingsAccountMailboxInfo());
    
    const suiteServiceUrl = `${window.location.origin}${getConfig().baseUrl}/service.svc`;
    const isHelpPaneFeedbackEnabled = isGlobalFeatureEnabled("help-pane-feedback");
    const isHelpPanePrivacyChoicesEnabled = isConsumer() && !isPremiumConsumer(getGlobalSettingsAccountMailboxInfo());
    const shellUseNpmMeControl = isGlobalFeatureEnabled("fwk-shell-useNpmMeControl");
    const getShellDataOverrides = React.useMemo(() => {
        return {
            SuiteServiceUrl: suiteServiceUrl,
            HideMyProfileLink: isShadowMailbox.current,
            HideMyAccountLink: isShadowMailbox.current,
            AppHeaderLinkText: props.AppHeaderLinkText,
            AppHeaderLinkUrl: props.AppHeaderLinkUrl,
            MAXHelpEnabled: !props.MAXHelpDisabled,
            FeedbackLink: isFeedbackEnabled ? feedbackNavLink : undefined,
            PrivacyChoicesLink: isHelpPanePrivacyChoicesEnabled
                ? privacyChoicesNavLink
                : undefined,
            MAXFeedbackUrl: format(MaxFeedbackPaneURLFormat, isConsumer() ? ConsumerSocUrl : BusinessSocUrl),
            DisableFeedbackLink: !isFeedbackEnabled || !isHelpPaneFeedbackEnabled,
            HelpLink: props.MAXHelpDisabled ? helpNavLink : undefined,
            UniversalMeControlEnabled: getApplicationSettings("UniversalMeControl").enabled,
            SocHelpUrl: isConsumer() ? ConsumerSocUrl : BusinessSocUrl,
            AccountSwitchingEnabled: accountSwitchingEnabled,
            NpmMeControlEnabled: shellUseNpmMeControl,
            // DO NOT OVERRIDE PrivacyLink and LegalLink here.
        };
    }, [
        suiteServiceUrl,
        props.AppHeaderLinkText,
        props.AppHeaderLinkUrl,
        props.MAXHelpDisabled,
        isFeedbackEnabled,
        isHelpPaneFeedbackEnabled,
        accountSwitchingEnabled,
        isOcpsStoreReady(),
    ]);
    
    const titleBarRef = React.useRef<HTMLDivElement | null>(null);
    const setTitleBarRef = React.useCallback((ref: HTMLDivElement) => {
        titleBarRef.current = ref;
    }, []);
    
    useInitializeViewportAdjustment(titleBarRef);
    
    const unblockPlt = useBlockPlt("suiteux");
    
    const suiteHeader = (<>
                <PendingAccountsWelcomeCallout />
                <ICloudSignInTeachingCallout />
                {isGlobalFeatureEnabled("settings-repromptDialog-v2") ? (<RepromptDialogV2 />) : (<RepromptDialog />)}
                {isGlobalFeatureEnabled("time-copilot-managed-events") && (<CopilotAutoReschedulingNotificationsCallout />)}
                {isIrisDialogEnabled() && <LazyIrisCampaignDialogHost />}
                {isGlobalFeatureEnabled("acct-pstFileSupport") && <LazyPstTeachingCallout />}
                <LazyAddSharedMailboxesAsAccountTeachingCallout />
                {isCapabilitySupported(customNotificationSoundCapability) && (<LazyNotificationSoundCustomizationTeachingCallout />)}
                <LazyF6TeachingBubble />
                {isFlightUpdateNotificationEnabled && (<StaleFlightUpdateButtonVisibility isVisible={isFlightUpdateAvailable}/>)}
                {searchContainerPortal}
                {searchScopePortal}
                {notificationPortal}
                <div id={OWA_TITLE_BAR_ID} ref={setTitleBarRef}>
                    <SuiteHeader onLinkClick={onLinkClick} culture={culture} language={language} isRTL={isRTL} isConsumer={isConsumer()} userDisplayName={sessionSettings?.UserDisplayName} userPrincipalName={userPrincipalName} workloadID={isGlobalFeatureEnabled("usv-nps-outlookDialog") ? "Monarch" : "Exchange"} appBrandTheme={APP_BRAND_THEME} currentMainLinkElementID={ShellMailId} themeData={themeDataOverride} customLayout={createCustomLayout()} meSublinks={createMeSublinks()} shellAssetsContainerOverride={getResourcePathUrl("suiteux-shell")} navBarData={navBarData} onSignOut={signOut} enableMicaForHeader={isCapabilityEnabled(headerFullBleedCapability)} onFlexPaneVisibilityChanged={onFlexPaneVisibilityChanged} helpSublinks={props.MAXHelpDisabled ? props.helpSublinks : undefined} shellDataOverrides={getShellDataOverrides} shellAuthProviderConfig={accountSwitchingEnabled && loginHintForAuth
            ? getAuthProviderConfig(loginHintForAuth)
            : undefined} loadedCallback={unblockPlt} renderedCallback={suiteRenderedCallback} chatButtonRenderedCallback={chatButtonRenderedCallback} supportShyHeaderMode={isCapabilityEnabled(shyHeaderCapability)} disableToasts={true} // This will turn off suite header toasts
     userID={sessionSettings?.UserPuid} helpNamespace={isGlobalFeatureEnabled("usv-nps-outlookDialog")
            ? "NWOUTWIN"
            : isConsumer()
                ? isGlobalFeatureEnabled("help-rave-tickets")
                    ? "OLWACB"
                    : "OLWAC"
                : undefined} shouldEnableChat={isChatEnabled} shouldLoadEmbedChatPreAuthOnIdle={isGlobalFeatureEnabled("fwk-teamsSDKPreAuth") &&
            isGlobalFeatureEnabled("fwk-teamsSuite")
            ? shouldLoadPreAuthOnIdleCallbackPromise
            : undefined} getUnreadChatCountOnIdle={isGlobalFeatureEnabled("fwk-teamsSuite")
            ? getChatUnreadMessageCallbackPromise
            : undefined} hideTenantLogoForInitialRender={hideTenantLogoForInitialRender} getTokenRequestDictionary={isGlobalFeatureEnabled("fwk-suite-fetchpreauthtoken")
            ? fetchTokenForShell
            : undefined}/>
                </div>
            </>);
    
    const wrapSuiteHeader = props.wrapSuiteHeader;
    const novaMeControl = isCapabilityEnabled(novaMeControlCapability)
        ? (MeControlLauncher as React.FC<{
            mailboxInfo: MailboxInfo;
        }>) // MeControlLauncher expects a mailboxInfo prop
        : undefined;
    
    const header: React.ReactNode = wrapSuiteHeader ? (wrapSuiteHeader(suiteHeader, novaMeControl)) : novaMeControl ? (<MeControlLauncher mailboxInfo={getMailboxInfoForMeControl()}/>) : (suiteHeader);
    
    return header;
}, "OwaSuiteHeader");
export default defaultExport;

function getAuthProviderConfig(loginHint: string) {
    const authProviderConfigType = isConsumer() ? "webMsaWithAadProxy" : "webAadWithMsaProxy";
    
    return {
        type: authProviderConfigType,
        login_Hint: loginHint,
        
        /* The appSignInUrl & appSignInToUrl are similar to the respective appSwitch urls,
                the difference being that these are meant for the app experience where there is
                no primary signed in user/user hasn't logged in yet. Since OWA doesn't have an
                this UX, setting these to match the corresponding appSwitch urls. */
        appSignInUrl: () => {
            return getSignInToDifferentAccountUrl();
        },
        
        appSignInToUrl: (params: any) => {
            return getAppSwitchToUrl(params);
        },
        
        /* This is the url used to signout the primary/logged in user. */
        appSignOutUrl: () => {
            return getAppSignOutUrl();
        },
        
        /* The appSwitchUrl is used for signing into a different account. */
        appSwitchUrl: () => {
            return getSignInToDifferentAccountUrl();
        },
        
        /* The appSwitchToUrl is used for switching to an account from the remembered accounts list,
           this is customised based on the type of account being switched to (aad vs msa). */
        appSwitchToUrl: (params: any) => {
            return getAppSwitchToUrl(params);
        },
        
        /* The wreply url for the aad & msa configs below, needs to be a ReplyTo Url registered with the respective identity provider, and should match the domain of the logged in user.
            It is used to generate the url to fetch remembered accounts, and signOut, signOutAndForget, forgetUser links that apply to each of the individual remembered accounts. */
        aad: {
            wreply: getReplyToUrl(),
            appId: getOwaAppId(),
        },
        msa: {
            wreply: getReplyToUrl(),
            siteId: OWA_CONSUMER_APP_ID, // TODO: custom consumer app id?
        },
    } as any;
}

function getAadLoginDomain() {
    // When the currently logged in user is an aad user, we want to use the same domain for logging into aad,
    // to account for scenarios where outlook.office.com domain could be blocked for the user.
    // If the MSAL consumer boot flight is enabled, the current domain will be returned as client-side MSAL can handle account switching.
    // When the logged in user is an MSA type, since the aad domain would be different from the user domain,
    // we are explicitly passing https://outlook.office.com
    if (!isConsumer()) {
        return getOrigin();
    }
    
    return OwaEnterpriseUrl;
}

function getReplyToUrl() {
    return `${getOrigin()}/${getRootVdirName()}/`;
}

function getAppSignOutUrl() {
    // Not passing SID value as part of logout URL will only remove browser cookies for the current user instead of signing out the user entirely.
    if (isConsumer()) {
        return `${getOrigin()}/mail/logoutframe.html?iss=${MsaTenantId}&loadMoreIframes=false&clearCookiesOnly=true`;
    }
    
    return `${getReplyToUrl()}logoutframe.html?loadMoreIframes=false&clearCookiesOnly=true`;
}

function getSignInToDifferentAccountUrl() {
    return `${getOrigin()}/${getRootVdirName()}/?${SELECT_ACCOUNT_PARAM}${getAppendBootFlightsParam()}`;
}

function getAppSwitchToUrl(params: any) {
    if (!params || !params.nextAccount) {
        return "";
    }
    
    // This aad login url is used when the account selected is an aad account type.
    const aadLogin = getAadLoginDomain();
    
    // This is the login domain used for switching to the selected account. This depends on the account type - when selected account
    // is aad type, aadLogin would be used, and for consumer type, live.com login would be used instead.
    const domain = params.nextAccount.type?.toLowerCase() == "aad" ? aadLogin : "https://outlook.live.com";
    
    const account = (isGlobalFeatureEnabled("auth-login-hint-suite-header") && params.nextAccount.login_hint) ||
        encodeURIComponent(params.nextAccount.memberName);
    const appSwitchToUrl = `${domain}/${getRootVdirName()}/?${LOGIN_HINT_PARAM}=${account}${getAppendBootFlightsParam()}`;
    
    return appSwitchToUrl;
}

function getAppendBootFlightsParam(): string {
    // Enable internal testing with 'appendbootflights' query parameter
    const bootflights = getQueryStringParameter(APPEND_BOOT_FLIGHTS_PARAM);
    const appendBootFlightParam = bootflights ? `&${APPEND_BOOT_FLIGHTS_PARAM}=${bootflights}` : "";
    
    return appendBootFlightParam;
}

function useReactPortal(renderFn: ((container: HTMLDivElement) => React.JSX.Element) | undefined) {
    /* eslint-disable-next-line owa-custom-rules/prefer-react-state-without-arrays-or-objects -- (https://aka.ms/OWALintWiki)
     * Please remove the array or object from React.useState() or leave a justification in case is not possible to do so.
     *	> It is preferable not to use arrays or objects as react state, destruct the state into primitive data types or use satchel instead. */
    const [container, setContainer] = useState<HTMLDivElement>();
    return [
        /* eslint-disable-next-line owa-custom-rules/no-unused-react-set-state -- (https://aka.ms/OWALintWiki)
         * DO NOT COPY-PASTE!, add a justification or fix the issue
         *	> React setState functions from useState should only be used by direct invocation, setState(), not passed or used as a value or used in hook's array dependencies. */
        setContainer,
        container && renderFn && createPortal(renderFn(container), container),
    ] as const;
}

function onLinkClick(data: LinkClickEventArgs) {
    if (data && data.Id == "Calendar") {
        logCoreUsage("ModuleSwitchToCalendar", getGlobalSettingsAccountMailboxInfo(), {
            source: "mailWaffle",
        }, { isScorecardEvent: true });
    }
}

function signOut(eventArgs: SignOutEventArgs) {
    eventArgs.triggerEvent.preventDefault();
    lazySignout.importAndExecute();
}

const onFlexPaneVisibilityChanged = (isVisible: boolean) => {
    setAppPaneUnderlayVisibility("suiteFlexPane", isVisible, true /* isShrinkable */);
};

function pushOnCondition(controlCollection: ShellControl[], control: ShellControl, condition?: boolean) {
    if (condition === undefined || condition) {
        controlCollection.push(control);
    }
}

function createHelpLink(id: string, helpText: string, url?: string, action?: () => void): NavBarLinkData {
    return {
        Id: id,
        Text: helpText,
        Url: url,
        TargetWindow: "_blank",
        Action: action,
    } as NavBarLinkData;
}

function showOpenAnotherMailboxDialog() {
    const [modalPromise] = showModal(OpenAnotherMailboxDialog);
    modalPromise.then(targetMailbox => {
        if (targetMailbox && targetMailbox.length > 0) {
            const encodedTargetMailbox = targetMailbox
                .split("@")
                .map(s => encodeURIComponent(s))
                .join("@");
            window.open(getNewScope(encodedTargetMailbox), "_blank");
        }
    });
}

function getWorkloadHelpSublinks(originalLinks: NavBarLinkData[] | null | undefined): NavBarLinkData[] {
    if (isWorkloadSupported(2)) {
        originalLinks = (originalLinks || []).concat([
            createHelpLink("OwaCalendarAbuseLink", loc(reportCalendarAbuseLink), "https://www.microsoft.com/concern/calendarabuse"),
        ]);
    }
    return originalLinks || [];
}
